// TODO: Get rid of this enum, this kind of information should be provided by the environment variables.
export enum Environment {
  Acceptance = 'acceptance',
  Production = 'production',
}
